import { render, staticRenderFns } from "./animatedLogo.vue?vue&type=template&id=3fbdc949&"
import script from "./animatedLogo.vue?vue&type=script&lang=js&"
export * from "./animatedLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports